var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Edit prompts",
        label: "Update",
        submitLoading: _vm.submitLoading,
        disabled: _vm.isDisabledSubmit
      },
      on: { "backdrop-close": _vm.onCancel, "backdrop-action": _vm.onSubmit }
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-col gap-4 px-8 overflow-y-auto",
          style: { width: "48rem", maxHeight: "calc(100vh - 16rem)" }
        },
        [
          _vm.format === "custom"
            ? _c(
                "div",
                {
                  staticClass:
                    "flex w-full gap-2 px-2 py-2 rounded bg-cornflower-200"
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-4 h-4 mt-1",
                    attrs: { icon: "toast-info", color: "cornflower-8" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        staticClass: "text-cornflower-800",
                        attrs: {
                          text:
                            "Editing the score for prompts will update the calculation of all existing records that use them."
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flex items-center justify-center p-4 border rounded bg-grey-100 h-76 border-grey-200"
            },
            [
              _c("PromptPreview", {
                style: { transform: "scale(0.5 , 0.5)" },
                attrs: { prompts: _vm.defaultPrompts }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {},
            [
              _c(
                "div",
                { staticClass: "flex items-center gap-4 mb-2" },
                [
                  _vm.format === "classic"
                    ? _c("div", { staticClass: "flex-shrink-0 w-2" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.format === "custom"
                    ? _c("BlTextSubtitle4", {
                        staticClass: "flex-shrink-0 w-15",
                        attrs: { text: "Score (%)" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("BlTextSubtitle4", {
                    staticClass: "flex-shrink-0 w-15",
                    attrs: { text: "Code" }
                  }),
                  _vm._v(" "),
                  _c("BlTextSubtitle4", {
                    staticClass: "flex-shrink-0 w-24",
                    attrs: { text: "Symbol" }
                  }),
                  _vm._v(" "),
                  _c("BlTextSubtitle4", {
                    staticClass: "w-full",
                    attrs: { text: "Prompt name" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-shrink-0 w-6" })
                ],
                1
              ),
              _vm._v(" "),
              _vm.format === "classic"
                ? _c(
                    "draggable",
                    {
                      staticClass: "flex flex-col gap-4",
                      attrs: { handle: ".handle" },
                      on: {
                        update: function($event) {
                          $event.preventDefault()
                          return _vm.onMovePosition($event)
                        }
                      }
                    },
                    _vm._l(_vm.defaultPrompts, function(prompt) {
                      return _c(
                        "div",
                        {
                          key: prompt.id,
                          staticClass: "flex items-center gap-4"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-center flex-shrink-0 w-2 text-sm handle cursor-grab text-grey-400"
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "flex-shrink-0 w-4",
                                attrs: { icon: "drag" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("PromptItem", {
                            attrs: {
                              prompt: prompt,
                              format: "classic",
                              directDelete: true,
                              disabledDelete:
                                _vm.isUsedToSuccessMetric(prompt.name) ||
                                prompt.is_used,
                              tooltipDelete: _vm.isUsedToSuccessMetric(
                                prompt.name
                              )
                                ? "You cannot delete this prompt because it has been used as a success metric."
                                : prompt.is_used
                                ? "You cannot delete this prompt because it has been used in the session."
                                : ""
                            },
                            on: { update: _vm.onUpdate, delete: _vm.onRemove }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.format === "custom"
                ? _c(
                    "div",
                    { staticClass: "flex flex-col gap-4" },
                    _vm._l(_vm.defaultPrompts, function(prompt) {
                      return _c("PromptItem", {
                        key: prompt.id,
                        attrs: {
                          prompt: prompt,
                          format: "custom",
                          directDelete: true,
                          disabledDelete:
                            _vm.isUsedToSuccessMetric(prompt.name) ||
                            prompt.is_used,
                          tooltipDelete: _vm.isUsedToSuccessMetric(prompt.name)
                            ? "You cannot delete this prompt because it has been used as a success metric."
                            : prompt.is_used
                            ? "You cannot delete this prompt because it has been used in the session."
                            : ""
                        },
                        on: { update: _vm.onUpdate, delete: _vm.onRemove }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex py-4" },
                [
                  _c("BlInputButton", {
                    staticClass: "px-0",
                    attrs: { icon: "plus", label: "Add prompt", type: "plain" },
                    on: { clicked: _vm.onAdd }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dd3a2e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dd3a2e1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/modal/EditPromptsModal.vue
// module id = null
// module chunks = 